document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  const closeBtn = document.querySelector('[data-cart-close]');
  const openDrawer = () => {
    if (!drawer || !overlay) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false;
    document.body.style.overflow = 'hidden';
  };
  const closeDrawer = () => {
    if (!drawer || !overlay) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true;
    document.body.style.overflow = '';
  };
  closeBtn?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(); });

  document.querySelectorAll('.cart-link').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (!drawer) return;
      event.preventDefault();
      openDrawer();
    });
  });

  const money = (cents) => {
    try {
      return new Intl.NumberFormat('en-PK', { style: 'currency', currency: 'PKR', maximumFractionDigits: 0 }).format(cents / 100).replace('PKR', 'Rs.');
    } catch (_) {
      return `Rs. ${Math.round(cents / 100).toLocaleString()}`;
    }
  };

  const refreshCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load cart');
    const cart = await response.json();
    document.querySelectorAll('.cart-count').forEach((node) => { node.textContent = cart.item_count; });
    const items = document.querySelector('[data-cart-items]');
    const footer = document.querySelector('[data-cart-footer]');
    const total = document.querySelector('[data-cart-total]');
    if (!items) return;
    if (!cart.item_count) {
      items.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p><a class="button button--secondary" href="/collections/all">Shop products</a></div>';
      if (footer) footer.hidden = true;
      return;
    }
    items.innerHTML = cart.items.map((item) => `
      <div class="cart-drawer__item">
        ${item.image ? `<img src="${item.image}" alt="${item.product_title.replace(/"/g, '&quot;')}" width="74" height="74">` : ''}
        <div><a class="cart-drawer__title" href="${item.url}">${item.product_title}</a><div class="cart-drawer__meta">Qty ${item.quantity} · ${money(item.final_line_price)}</div></div>
      </div>`).join('');
    if (total) total.textContent = money(cart.total_price);
    if (footer) footer.hidden = false;
  };

  document.querySelectorAll('[data-product-form]').forEach((formWrap) => {
    const select = formWrap.querySelector('[data-variant-select]');
    const idInput = formWrap.querySelector('[name="id"]');
    const price = formWrap.querySelector('[data-product-price]');
    const compare = formWrap.querySelector('[data-product-compare]');
    const button = formWrap.querySelector('[type="submit"]');
    if (select && idInput) {
      const syncVariant = () => {
        const option = select.options[select.selectedIndex];
        idInput.value = option.value;
        if (price) price.textContent = option.dataset.price || '';
        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.hidden = !option.dataset.compare;
        }
        const available = option.dataset.available === 'true';
        if (button) {
          button.disabled = !available;
          button.textContent = available ? 'Add to cart' : 'Sold out';
        }
      };
      select.addEventListener('change', syncVariant);
      syncVariant();
    }

    const form = formWrap.querySelector('form[action*="/cart/add"]');
    if (form && window.fetch) {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const submit = form.querySelector('[type="submit"]');
        if (submit?.disabled) return;
        const oldText = submit?.textContent;
        if (submit) { submit.disabled = true; submit.textContent = 'Adding…'; }
        try {
          const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Unable to add this product');
          await refreshCart();
          openDrawer();
        } catch (error) {
          window.alert(error.message || 'Unable to add this product. Please try again.');
        } finally {
          if (submit) { submit.disabled = false; submit.textContent = oldText || 'Add to cart'; }
        }
      });
    }
  });
});
